import { render } from "./VideoPanel.vue?vue&type=template&id=07af6ba6&scoped=true"
import script from "./VideoPanel.vue?vue&type=script&lang=js"
export * from "./VideoPanel.vue?vue&type=script&lang=js"

import "./VideoPanel.vue?vue&type=style&index=0&id=07af6ba6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07af6ba6"]])

export default __exports__